import { render, staticRenderFns } from "./SubscriptionsTableCp.vue?vue&type=template&id=a38bb68a"
import script from "./SubscriptionsTableCp.vue?vue&type=script&lang=js"
export * from "./SubscriptionsTableCp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports